<template>
  <el-dialog
    title=""
    customClass="lookEvaluateDialog"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :append-to-body="true"
    :modal-append-to-body="true"
  >
    <div class="title">查看评价</div>
    <div class="order-no">
      <span>订单编号</span>
      <span class="val">{{info.orderNo}}</span>
    </div>
    <div class="evaluate-content">
      <div class="left">
        <img :src="info.mainPic" alt="">
        <p class="name">{{info.goodsName}}</p>
        <p class="price">￥{{info.paymentTotal}}</p>
      </div>
      <div class="right">
        <div class="module">
          <p class="sub-title">整体评分</p>
          <el-rate v-model="info.score" disabled></el-rate>
          <p class="grade">{{info.score}}分</p>
        </div>
        <div class="module mt40">
          <p class="sub-title">晒图评论</p>
          <p class="describe">{{info.content}}</p>
        </div>
        <div class="pic-list" v-if="info.pictures">
          <img v-for="(item, index) in info.pictures" :key="index" :src="item.url" alt="">
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getReview } from '@/api/myOrder'
export default {
  name: 'LookEvaluateDialog',
  data () {
    return {
      info: {},
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    handleOpenDialog (item) {
      this.loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getReview(item.orderNo).then(res => {
        if (res.code === 0) {
          if (res.data.pictures) {
            res.data.pictures = JSON.parse(res.data.pictures)
          }
          this.info = { ...item, ...res.data }
          this.dialogVisible = true
          this.loading.close()
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.lookEvaluateDialog{
  background: #FFFFFF;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;
  width: unset;
  max-width: 70%;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 40px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }
  .title{
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    color: #9B232A;
    margin-bottom: 20px;
  }
  .order-no {
    padding-bottom: 20px;
    border-bottom: 1px solid #8FA8BC;
    opacity: 0.5;
    font-size: 16px;
    color: #9FA1B0;
    .val {
      color: #44516F;
      margin-left: 30px;
    }
  }
  .evaluate-content {
    padding: 40px 0;
    display: flex;
    .left {
      text-align: center;
      width: 160px;
      img {
        width: 160px;
        height: 160px;
      }
      .name {
        font-size: 14px;
        color: #242B34;
        margin-top: 8px;
        line-height: 20px;
      }
      .price {
        font-size: 16px;
        font-weight: bold;
        color: #1D263A;
        margin-top: 8px;
      }
    }
    .right {
      margin-left: 24px;
      .module {
        display: flex;
        align-items: center;
        .el-rate {
          height: 30px;
        }
        .el-rate__icon {
          font-size: 28px;
        }
        .sub-title {
          width: 72px;
          font-size: 18px;
          font-weight: bold;
          color: #242B34;
          margin-right: 12px;
        }
        .grade {
          font-size: 18px;
          font-weight: bold;
          color: #FF0000;
          margin-left: 12px;
        }
        .mt40 {
          margin-top: 40px;
        }
        .describe {
          font-size: 14px;
          color: #44516F;
        }
      }
      .pic-list {
        margin: 12px 0 0 72px;
        img {
          width: 80px;
          height: 80px;
          margin-left: 12px;
        }

      }
    }
  }
}
</style>
